<template>
  <lazy-component
    class="article-block"
    :class="blockStyle"
  >
    <div
      class="article-block__image"
    >
      <a 
        :href="articleUrl" 
        :rel="linkRel"
      >
        <img
          :src="article.homePageImage || article.image"
          :alt="article.title"
        >
      </a>
    </div>
    <div class="article-block__content">
      <div class="article-block__body">
        <h3 v-if="showCategory && article.categories && article.categories.length > 0" class="article-block__category">
          {{ $t(article.categories[0].name) }}
        </h3>
        <a
          class="article-block__title"
          :href="articleUrl"
          :rel="linkRel"
          style="-webkit-box-orient: vertical;"
        >
          <h2>
            {{ articleTitle }}
          </h2>

          <label class="article-block__author">
            By {{ article.author ? article.author : "Bandwagon" }}
            <template v-if="article.publishedAt">
              on {{ formattedPublishedAt }}
            </template>
          </label>
        </a>
      </div>
      <div class="article-block__footer">
        <a
          v-if="action"
          class="article-block__action"
          :href="articleUrl"
        >
          {{ action }}
        </a>
        <div class="article-block__spins" v-if="article.spins">
          <label
            v-if="article.genre"
            class="article-block__genre">{{ article.genre }}</label>
          <label>SPINS</label>
          <i class="bandwagon-logo bandwagon-logo--arc" />
          <label class="article-block__spins-number">{{ article.spins }}</label>
        </div>
      </div>
    </div>
  </lazy-component>
</template>

<script>
export default {
  name: 'ArticleBlockComponent',
  props: {
    fixedStyle: {
      type: String,
      default: 'list-item',
    },
    action: {
      type: String,
      default: undefined,
    },
    article: {
      type: Object,
      default: () => ({}),
    },
    showCategory: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    articleUrl() {
      const language = this.article.languageInCountry;

      return `${this.article.url}${language ? `/${language}` : ''}`;
    },

    articleTitle() {
      return this.article.titleInCountry || this.article.title;
    },

    blockStyle() {
      if (this.article.isPaid) {
        return `article-block--is-paid article-block--${this.fixedStyle}`;
      }
      return `article-block--${this.fixedStyle}`;
    },

    linkRel() {
      return this.article.isPaid ? "nofollow" : null;
    },

    formattedPublishedAt() {
      if (this.article.publishedAt === undefined) return '';

      return (new Date(this.article.publishedAt)).toLocaleString('en-SG', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
    },
  },
};
</script>
